export { IdentitiesItem as default };

/**
* Identities Item Data
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class IdentitiesItem {
  /**
   * Identity id
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  id;

  /**
   * Identity index
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  index;

  /**
   * Identity Name
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  name;

  /**
   * Identity E-mail
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  email;

  /**
   * Defines if identity is an alias
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  is_alias;

  /**
   * List of Bccs to add
   *
   * @public
   *
   * @type {Array}
   *
   * @since 7.0.0
   */
  bccs = [];

  /**
   * HTMl Signature
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  signature_html;

  /**
   * Defines if is default identity
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  default;
}